import { type FC } from 'react';
import {
  UiIconWarningDiamond
} from '@/lib/ui';
import Base, { type BaseProps } from './Base';

export type MessageBarWarningProps = Omit<BaseProps, 'icon'>;

export const BaseMessageBarWarning: FC<MessageBarWarningProps> = (props) => {
  return (
    <Base
      textProps={{
        variant: 'body1'
      }}
      icon={<UiIconWarningDiamond size={'2xl'} color={'text.primary'} />}
      bgColor={'red.100'}
      {...props}
    />
  );
};

export default BaseMessageBarWarning;
